import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { EmployeeConfigMaster } from '../../../models/config/EmployeeConfigMaster';
import { ResponseError } from '../../../models/common/Response';

export function useAddEmployeeConfigMaster(
    options?: UseMutationOptions<
        EmployeeConfigMaster,
        AxiosError<ResponseError>,
        EmployeeConfigMaster
    >
) {
    return useMutation({
        mutationFn: (request) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.post('/v1/configuration/lis/employee', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
        },
        ...options,
    });
}
